import { useEffect, useState, createContext } from 'react';
import { SPORTS_WITH_STAGE_ID } from '../constants';
import { getConfiguration } from '../utils/configuration';
import { initBetradarWidgetS5 } from './betradarWidgetS5';
import { xs_languageCode } from '../..';

export const PROVIDER_BETRADAR_WIDGET  = 1;
export const PROVIDER_BETGENIUS_WIDGET = 2;
export const PROVIDER_FLASHBET_WIDGET  = 3;
export const PROVIDER_STATSCORE_WIDGET = 4;

export const STATSCORE_WIDGET_LIVESCORE = 'livescore';
export const STATSCORE_WIDGET_PREMATCH_PRO = 'prematchPro';
export const STATSCORE_WIDGET_STATS = 'stats';

export const WidgetContext = createContext(null);

export function brWidgetEnabled(sportId, widgetType) {
    const sps = getConfiguration()?.ps.lte['BETRADAR_WIDGET']?.sps;
    const isBetradar = !widgetType || widgetType === PROVIDER_BETRADAR_WIDGET;
    return sps?.[sportId] !== undefined && isBetradar;
}

export function brWidgetS5Enabled(sportId, widgetType) {
    const sps = getConfiguration()?.ps.lte['BETRADAR_WIDGET_S5']?.sps;
    const isBetradar = !widgetType || widgetType === PROVIDER_BETRADAR_WIDGET;
    return sps?.[sportId] !== undefined && isBetradar;
}

export function getFlashbetWidgetUrl(widgetType) {
    const isFlashbet = !widgetType || widgetType === PROVIDER_FLASHBET_WIDGET;
    return getConfiguration()?.ps.lte['FLASHBET_WIDGET']?.['ujs']?.['ALL'] && isFlashbet;
}

export function bgWidgetEnabled(sportId, widgetType, geniusId) {
    const sps = getConfiguration()?.ps.lte['BETGENIUS_WIDGET']?.sps;
    const isBetgenius = (!widgetType || widgetType === PROVIDER_BETGENIUS_WIDGET) && (geniusId || 0) != 0;
    return sps?.[sportId] !== undefined && isBetgenius;
}

export function statsCoreWidgetEnabled(lsConfIdType, widgetType, lsportWidgetId) {
    const lscid =  getConfiguration()?.ps.lte['LSPORT_WIDGET']?.lscid;
    const isLsport = widgetType === PROVIDER_STATSCORE_WIDGET && lsportWidgetId != 0;
    return lscid?.[lsConfIdType] !== undefined && isLsport;
}

export function getBetgeniustWidgetUrl(sportId, categoryId, tournamentId) {
    const ujs =  getConfiguration()?.ps.lte['BETGENIUS_WIDGET']?.['ujs'];
    const keyAll = 'ALL';
    const keyTournament = [sportId, categoryId, tournamentId].join('_');
    const keyAllTournamentsInCategory = [sportId, categoryId, 'ALL'].join('_');
    if(ujs?.[keyTournament]){
    	return ujs[keyTournament];
    }
    if(ujs?.[keyAllTournamentsInCategory]){
    	return ujs[keyAllTournamentsInCategory];
    }
    return ujs?.[sportId] ?? ujs[keyAll];
}

export function isWidgetEnabled(sportId, widgetType, geniusId, lsportWidgetId) {
    return brWidgetEnabled(sportId,widgetType) || brWidgetS5Enabled (sportId, widgetType) || 
           getFlashbetWidgetUrl(widgetType) || bgWidgetEnabled(sportId,widgetType, geniusId) ||  
           statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE,widgetType, lsportWidgetId);
}

export function getStatsCoreConfigurationId(lsConfIdType){
    const lscid = getConfiguration()?.ps.lte['LSPORT_WIDGET']?.lscid;
    return lscid?.[lsConfIdType] ?? null;
}

const sectionsToIgnore = [
    'checkbet',
    'checksystembets',
    'multi-live',
    'mybets'
];

export function useWidgetContext(wdgtCntnrId = '#collassaWidget') {
    const initWdgtCtx = {
        isWidgetToggleable: true,
        widgetSportId: null,
        widgetMatchId: null,
        widgetContainerId: wdgtCntnrId,
        widgetGeniusId: null,
        widgetLsportId: null,
        widgetProviderType: null,
        widgetStartCollapsed: false,
        widgetShowSidebar: false,
        widgetS5Layout: null,
        currentSection: null
    }

    const [context, setContext] = useState({
        ...initWdgtCtx,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        reset() {
            this.update({...initWdgtCtx});
        },
        setWidget(settings) {
            this.update({
                ...settings
            });
        }
    });

    const [widgetState, setWidgetState] = useState({
        handle: null,
        matchId: null,
        containerId: wdgtCntnrId,
    });
    
    useEffect(function() {
        const newMatchId = context.widgetMatchId;
        const newContainerId = context.widgetContainerId;

        // Se è già attivo il widget, rimuovilo in questi due casi:
        // 1) Il match id è diventato null oppure il container id e' diventato null
        // 2) Il match id è cambiato e non sono su sezione "multi-live"
        // 3) Il container id e' cambiato  e non sono su sezione "multi-live"
        if (widgetState.handle != null && (newMatchId == null || newContainerId == null || (!sectionsToIgnore.includes(context.currentSection) && (newMatchId !== widgetState.matchId || newContainerId !== widgetState.containerId)))) {
            if (brWidgetEnabled(context.widgetSportId,context.widgetProviderType)) {
                if (window.SRLive != null) {
                    window.SRLive.removeWidget(widgetState.handle);
                    setWidgetState({
                        handle: null,
                        //widgetMatchId: newMatchId,
                        matchId: newMatchId,
                        containerId: newContainerId
                    });
                }
            } else if (brWidgetS5Enabled(context.widgetSportId,context.widgetProviderType)) {
                //TODO handle widget close
            }
        }
        
        // Se il match id non è null ed è cambiato oppure il container id è cambiato, attiva il nuovo widget
        if (newMatchId != null && newContainerId != null && (newMatchId !== widgetState.matchId || newContainerId !== widgetState.containerId)) {
            if (brWidgetEnabled(context.widgetSportId,context.widgetProviderType) && newMatchId >= 0) {
                let brWidgetSettings = {
                    name : "widgets.lmts",
                    config :{
                        "height": false,
                        "showScoreboard": true, //risultato (in alto)
                        "showMomentum": false, //timeline
                        "showMomentum2": false, //timeline
                        "showPitch": true,
                        "showSidebar": context.widgetShowSidebar, // statistiche
                        "showGoalscorers": false,
                        "sidebarLayout": "dynamic",
                        "collapse_enabled": true,
                        "collapse_startCollapsed": context.widgetStartCollapsed,
                        "matchId": newMatchId,
                        "showTitle": false,
                        "momentum2_showArea": false,
                        "pitchCrowd": true,
                        "container": context.widgetContainerId,
                    }
                };
                                
                if (window.SRLive != null) {
                    setWidgetState({
                        handle: window.SRLive.addWidget(brWidgetSettings),
                        //widgetMatchId: newMatchId,
                        matchId: newMatchId,
                        containerId: newContainerId
                    });
                }
            } else if (brWidgetS5Enabled(context.widgetSportId,context.widgetProviderType)) {
                if(newMatchId >= 0){
                    open5SWidget(newMatchId,  context.widgetContainerId, context.widgetSportId);
                }else{
                    close5SWidget(newMatchId,  context.widgetContainerId, context.widgetSportId);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.widgetMatchId, context.widgetContainerId]);

    function open5SWidget(matchId, containerId, sportID) {
        if (window.SIR == null) {
            const conf = getConfiguration();
            const s5_URL = conf.ps.lte['BETRADAR_WIDGET_S5']?.['ujs']?.['ALL'] ?? null;
            if (s5_URL == null) {
                return;
            }
            initBetradarWidgetS5(s5_URL,xs_languageCode, () => {
                // Call the function again, but this time it will enter the else branch
                open5SWidget(matchId, containerId, sportID);
            });
        } else {
            try {
                const type = SPORTS_WITH_STAGE_ID.includes(sportID) ? 'match.lmtPlus.f1' : 'match.lmtPlus';
                return  window.SIR('addWidget', containerId, type, getSIRWidgetProps(context.widgetS5Layout, matchId, sportID));
            }catch(err) {
                console.error(err);
                try {
                    close5SWidget(matchId, containerId, sportID);
                }catch(err) {
                    console.error(err);
                }
            }
            
        }
    }

    function close5SWidget(matchId, containerId, sportID) {
        if (window.SIR == null) {
            return;
        }
        const type = SPORTS_WITH_STAGE_ID.includes(sportID) ? 'match.lmtPlus.f1' : 'match.lmtPlus';
        return window.SIR('removeWidget', containerId, type, getSIRWidgetProps(context.widgetS5Layout, matchId, sportID));
    }

    function getSIRWidgetProps(type, matchId, sportID) {
        /*let widgetSkinConf = {};
        try{
            widgetSkinConf = JSON.parse(CUSTOMERS.get(SYSTEM_CODE).widgetBetradarInfo);
        }catch(e){}*/
        
        if (type == null) {
            type='#1'
        }
        
        let props = {};
        if (type === '#1') { //EVENTO SINGOLO DESKTOP DX
            if (SPORTS_WITH_STAGE_ID.includes(sportID)) {
                props = {layout: 'topdown', stageId: matchId, scoreboard: 'extended', collapseTo: 'disable', hideExpand: true};
            } else {
                props = {layout: 'topdown', matchId: matchId, scoreboard: 'extended', momentum: 'extended'};
            }
        } else if (type === '#2') { //EVENTO SINGOLO DESKTOP TOP
            if (SPORTS_WITH_STAGE_ID.includes(sportID)) {
                /* Workaround: scommettendo ha come tipo di default "#2" (evento singolo desktop) anche sul mobile, essendo la configurazione in comune tra desktop e mobile.
                   E' necessario però distinguere il caso mobile F1 dal caso desktop. Viene utilizzato quindi l'id #br_widget che è presente solo sul mobile.
                */
                if (context.widgetContainerId === '#br_widget') {
                    props = {stageId: matchId, scoreboard: 'extended', collapseTo: 'disable', 'hideExpand': true};
                } else {
                    props = {layout: 'topdown', stageId: matchId, scoreboard: 'extended', collapseTo: 'disable'};
                }
            } else {
                props = {
                    collapseTo: 'momentum',
                    matchId: matchId, 
                    scoreboard: 'extended', 
                    momentum: 'extended',
                    tabsPosition: 'top'
                };
            }
        } else if (type === '#3') { //LIVE SUITE
            if (SPORTS_WITH_STAGE_ID.includes(sportID)) {
                props = {stageId: matchId, scoreboard: 'extended', collapseTo: 'disable', hideExpand: true};
            } else {
                props = {
                    layout: 'topdown',
                    scoreboard: 'compact', 
                    detailedScoreboard: 'enable', 
                    collapseTo: 'pitch',
                    matchId: matchId, 
                    momentum: 'disable',
                    tabsPosition: 'top'
                };
            }
        } else if (type === '#4') { //EVENTO SINGOLO MOBILE 
            if (SPORTS_WITH_STAGE_ID.includes(sportID)) {
                props = {layout: 'topdown', stageId: matchId, scoreboard: 'extended', collapseTo: 'disable'};
            } else {
                props = {
                    momentum: 'disable', 
                    collapseTo: 'pitch',
                    matchId: matchId,                  
                    tabsPosition: 'top'
                };
            }
        } else if (type === '#5') { // EVENTO SINGOLO TERMINALE SELF
            props = {
                layout: 'double',
                matchId: matchId, 
                scoreboard: 'extended',
                tabsPosition: 'bottom',
            };
        } else if (type === '#6') { // EVENTO DOPPIO TERMINALE SELF
            props = {
                collapseTo: 'pitch',
                layout: 'topdown',
                matchId: matchId, 
                scoreboard: 'compact',
                tabsPosition: 'bottom',
            };
        } else if (type === '#7') { // MAGNUMBET MOBILE FRONT END
            props = {
                layout: 'single',
                scoreboard: 'disable',
                detailedScoreboard: 'disable',
                collapseTo: 'disable',
                tabsPosition: 'disable',
                matchId
            };
        } else if (type === '#8') { // MAGNUMBET MOBILE FRONT END
            props = {
                // layout: 'single',
                scoreboard: 'disable',
                detailedScoreboard: 'disable',
                // collapseTo: 'disable',
                // tabsPosition: 'disable',
                matchId
            };
        } else if (type === '#9'){ //EVENTO SINGOLO MOBILE 
            if (SPORTS_WITH_STAGE_ID.includes(sportID)) {
                props = {
                    showOdds: 'false',
                    adsFrequency: 'false',
                    layout: 'double',
                    activeSwitcher: 'scoreDetails',
                    momentum: 'extended',
                    collapseTo: 'momentum',
                    theme: 'false',
                    stageId: matchId,
                    scoreboard: 'extended',
                    tabsPosition: 'top'
                };

            } else {
                props = {
                    showOdds: 'false',
                    adsFrequency: 'false',
                    layout: 'double',
                    activeSwitcher: 'scoreDetails',
                    momentum: 'extended',
                    collapseTo: 'momentum',
                    theme: 'false',
                    matchId: matchId,
                    tabsPosition: 'top'
                };
            }
        }
        
        /*if(widgetSkinConf.logo != undefined){
            props.pitchLogo = widgetSkinConf.logo; 
            props.goalBannerImage = widgetSkinConf.logo;
            props.logo = [widgetSkinConf.logo];
        }*/
        
        return props;
    }

    return [context, setContext];
}
